import { jsxs, jsx } from 'react/jsx-runtime';
import { inNextServer } from '@fabric-app/compat';
import { FaviconImage } from './FaviconImage.js';
import React__default, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { styled } from 'styled-components';
import { create } from 'zustand';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { useOnClickOutside } from '@fabric-app/hooks/useOnClickOutside';
import { LinkExternalIcon } from '@fabric-app/icons/icons';

const HoverItemContainer = styled.div.withConfig({
  displayName: "HoverItem__HoverItemContainer",
  componentId: "sc-d0a9308d-0"
})([
  `z-index:20;pointer-events:none;position:fixed;color:white;background-color:#111;border:1px solid var(--fabric-color-border-primary);max-width:500px;padding:8px;border-radius:10px;overflow:hidden;display:flex;flex-direction:column;gap:4px;`
]);
const HoverItemHeader = styled.div.withConfig({
  displayName: "HoverItem__HoverItemHeader",
  componentId: "sc-d0a9308d-1"
})([
  `display:flex;align-items:center;gap:6px;font-weight:400;font-size:16px;line-height:19px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;> span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}svg{margin-left:10px;}`
]);
const FaviconWrapper = styled.div.withConfig({
  displayName: "HoverItem__FaviconWrapper",
  componentId: "sc-d0a9308d-2"
})([
  `display:flex;align-items:center;justify-content:center;height:16px;margin-top:-1px;flex-shrink:0;`
]);
const StyledFaviconImage = styled(FaviconImage).withConfig({
  displayName: "HoverItem__StyledFaviconImage",
  componentId: "sc-d0a9308d-3"
})([
  `flex-shrink:0;height:16px;width:16px;`
]);
const HoverItemUrl = styled.div.withConfig({
  displayName: "HoverItem__HoverItemUrl",
  componentId: "sc-d0a9308d-4"
})([
  `color:#d0d0d0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;> span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}font-weight:500;font-size:13px;line-height:16px;margin:0;`
]);
const HoverState = create()((set) => ({
  showId: "",
  setShowId: (showId) => set(() => ({
    showId
  }))
}));
const HoverItem = ({ fdocId, show, faviconUrl, setShow, x, y, title, url }) => {
  const { showId, setShowId } = HoverState();
  useEffect(() => {
    if (!show) return;
    setShowId(fdocId);
  }, [
    show,
    fdocId,
    setShowId
  ]);
  useEffect(() => {
    if (showId !== fdocId) {
      setShow(false);
    }
  }, [
    showId,
    fdocId,
    setShow
  ]);
  const [ref, setRef] = React__default.useState(null);
  const [flip, setFlip] = React__default.useState(false);
  useClientLayoutEffect(() => {
    if (!ref) return;
    const updateFlip = () => {
      const rect = ref.getBoundingClientRect();
      const rightEdge = x + rect.width;
      setFlip(rightEdge > window.innerWidth);
    };
    updateFlip();
    const resizeObserver = new ResizeObserver(updateFlip);
    resizeObserver.observe(ref);
    window.addEventListener("resize", updateFlip);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateFlip);
    };
  }, [
    ref,
    x
  ]);
  useOnClickOutside(ref, () => {
    setShow(false);
  });
  if (inNextServer()) return null;
  const portalTarget = document.getElementById("tooltip-portal");
  const element = /* @__PURE__ */ jsxs(HoverItemContainer, {
    style: {
      top: y + 10,
      left: x + 10,
      display: !show || x === 0 && y === 0 ? "none" : void 0,
      transform: flip ? "translateX(-100%)" : void 0
    },
    ref: setRef,
    children: [
      /* @__PURE__ */ jsxs(HoverItemHeader, {
        children: [
          /* @__PURE__ */ jsx(FaviconWrapper, {
            children: /* @__PURE__ */ jsx(StyledFaviconImage, {
              faviconUrl,
              pageUrl: url
            })
          }),
          /* @__PURE__ */ jsx("span", {
            children: title
          }),
          /* @__PURE__ */ jsx(LinkExternalIcon, {
            size: 16,
            style: {
              marginLeft: "auto",
              alignSelf: "flex-start"
            }
          })
        ]
      }),
      /* @__PURE__ */ jsx(HoverItemUrl, {
        children: /* @__PURE__ */ jsx("span", {
          children: url
        })
      })
    ]
  });
  if (!show) return null;
  return portalTarget ? /* @__PURE__ */ createPortal(element, portalTarget) : element;
};

export { HoverItem as default };
//# sourceMappingURL=HoverItem.js.map
